import { ROUTES } from '#/config/routes';
import {
  createTextFilterMeta,
  createTreeMultiFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

export function buildMtrTemplateColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.mtrTemplateEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
    },
    {
      id: 'mtrStructMain',
      header: '主分類',
      accessorFn: (row) => row.mtrStructMain?.name ?? '-',
      size: 120,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructMainId',
        label: '主分類',
        treeRole: 'main',
        filterValue: filters.mtrStructMainId,
        onChange: (value) => onFilterChange('mtrStructMainId', value),
      }),
    },
    {
      id: 'mtrStructSub',
      header: '次分類',
      accessorFn: (row) => row.mtrStructSub?.name ?? '-',
      size: 120,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructSubId',
        label: '次分類',
        treeRole: 'sub',
        filterValue: filters.mtrStructSubId,
        onChange: (value) => onFilterChange('mtrStructSubId', value),
      }),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}
